import { Navigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';
import { AUTH_TOKEN, LINKS } from '../constants';

type PublicRouteProps = {
  children: JSX.Element;
  /** When true, logged-in users still see this route (e.g. sales coupon links for existing customers). */
  allowAuthenticated?: boolean;
};

/**
 * PublicRoute wraps routes that are primarily for guests (login, register, etc.).
 * By default, authenticated users are redirected to dashboard or onboarding.
 * Use allowAuthenticated for pages that must work for both guests and logged-in users.
 */
export const PublicRoute = ({ children, allowAuthenticated = false }: PublicRouteProps) => {
  const { isAppUserLoggedIn, currentUser } = useAppContext();
  const location = useLocation();
  const token = localStorage.getItem(AUTH_TOKEN);

  if (allowAuthenticated) {
    return children;
  }

  if (token && isAppUserLoggedIn && currentUser) {
    const { isSubscribed } = currentUser || {};
    const { subscriptionCancelled, customerStripeId } = isSubscribed || {};
    if (customerStripeId || subscriptionCancelled) {
      return <Navigate to={LINKS.DASHBOARD_LINK} state={{ from: location }} replace />;
    } else {
      return <Navigate to={LINKS.ONBOARDING_LINK} state={{ from: location }} replace />;
    }
  } else {
    return children;
  }
};
